<div class="ion-padding">
  <div class="smodules-wrapper">
    <swiper-container id="swiper-container-{{b.id}}" [options]="smodulesOptions" init="false">

      <swiper-slide *ngFor="let sm of slides;">
        <button type="button" (click)="navigate2(sm)" class="btn-reset smodule-box" [ngStyle]="{'background-image': 'url(' + safeURL(mediaUrl(sm.image)) + ')'}">
          <div class="smodule-box-title" [innerHTML]="sm.title"></div>
          <ion-icon *ngIf="isboxVisited(sm)" src="/assets/custom-ion-icons/check-mark.svg"></ion-icon>
        </button>
      </swiper-slide>

    </swiper-container>
  </div>
</div>